import { ToastContainer } from 'react-toastify'
import styled from 'styled-components'
import 'react-toastify/dist/ReactToastify.css'

const success = '#008059'
const info = '#000'
const StyledContainer = styled(ToastContainer).attrs({})`
  .Toastify__toast--success {
    background: ${success} !important;
  }
  .Toastify__toast--info {
    background: ${info} !important;
  }
`

export const AlertContainer = () => <StyledContainer />
